import { Component, inject } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrButton } from '../lvr-button/lvr-button';

export interface GenericDialogData {
	titleKey: string;
	messageKey?: string;
	confirmKey?: string;
	cancelKey?: string;
	contextLabel?: string;
	iconCancel?: string;
	iconConfirm?: string;
}

@Component({
	selector: 'lvr-generic-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	templateUrl: './generic-dialog.html',
})
export class GenericDialog {
	public readonly dialogRef = inject<MatDialogRef<GenericDialog>>(MatDialogRef);
	public readonly data = inject<GenericDialogData>(MAT_DIALOG_DATA);
}
